"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.detail = void 0;
const timezone_enum_1 = __importDefault(require("timezone-enum"));
const IdentifierType_1 = require("../../enums/game/IdentifierType");
exports.detail = {
    identifierType: IdentifierType_1.IdentifierType.NULL,
    identifierFormInputType: '',
    font: 'bebas',
    isAudioAvailable: true,
    isAudioAutoPlay: false,
    timeZone: timezone_enum_1.default['Europe/Stockholm'],
    background: 'https://prod-cdn.flarie.com/asset/game-center/website-bg.png',
    gameCenterId: null,
    isPauseViewEnabled: false,
    gamificationId: null,
    gamificationType: null,
};
